import React, { useMemo, useState } from "react";
import Header from "../../Include/Header";
import Sidebar from "../../Include/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import { Pagination, Search } from "../../Table";
import DropDown from "../../../../Components/DropDown";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMaterialReceiveData } from "../../../../Store/Erp/MaterialReceive/getMaterialData";
import Loader from "../../../Store/Include/Loader";
import Swal from "sweetalert2";
import { V_URL } from "../../../../BaseUrl";
import axios from "axios";

const MaterialReceiveList = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => setIsSidebarOpen(!isSidebarOpen);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  // const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);
  const [loading, setLoading] = useState(false);

  const project_id = localStorage.getItem("U_PROJECT_ID");

  const fetchMaterialData = async () => {
    setLoading(true);
    try {
      await dispatch(getMaterialReceiveData({
        project_id,
        page: currentPage,
        limit,
      }));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMaterialData();
  }, [currentPage, limit, search]);

  const entity = useSelector(
    (state) => state?.materialReceiveDataList?.user?.data
  );

  const list = entity?.list || [];
  const pagination = entity?.pagination || {};
  const totalItems = entity?.pagination?.totalCount || 0;


  const tableData = useMemo(() => {
    let data = [...list];

    if (search) {
      const keyword = search.toLowerCase();
      data = data?.filter((item) =>
        item.voucher_no.toLowerCase().includes(keyword)
      );
    }

    return data;
  }, [list, search]);

  const handleDelete = async (id, voucher_no) => {
    const result = await Swal.fire({
      title: `Delete Voucher ${voucher_no}?`,
      text: "Are you sure you want to delete this voucher?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const token = localStorage.getItem("PAY_USER_TOKEN");

      const myUrl = `${V_URL}/user/receive-issue-delete-status/${id}`;

      const res = await axios.put(
        myUrl,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res?.data?.success) {
        Swal.fire("Deleted!", "Material deleted successfully.", "success");
        fetchMaterialData();
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Delete failed.",
          "error"
        );
      }
    } catch (error) {
      console.error("Delete error:", error);
      Swal.fire(
        "Can Not Delete",
        error?.response?.data?.message || "Something went wrong.",
        "error"
      );
    }
  };

  const handleRefresh = () => {
    setSearch("");
    setCurrentPage(1);
    fetchMaterialData();
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/user/project-store/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right"></i>
                  </li>
                  <li className="breadcrumb-item active">Material Receive</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Material Receive</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <Search
                                  onSearch={(value) => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                  }}
                                />
                                <a className="btn">
                                  <img
                                    src="/assets/img/icons/search-normal.svg"
                                    alt=""
                                  />
                                </a>
                              </form>
                            </div>

                            <div className="add-group">
                              <Link
                                to="/user/project-store/manage-item-receive"
                                className="btn btn-primary add-pluss ms-2"
                                title="Add"
                              >
                                <img
                                  src="/assets/img/icons/plus.svg"
                                  alt="plus-icon"
                                />
                              </Link>

                              <button
                                type="button"
                                className="btn btn-primary doctor-refresh ms-2"
                                onClick={handleRefresh}
                                title="Refresh"
                              >
                                <img
                                  src="/assets/img/icons/re-fresh.svg"
                                  alt="refresh"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                        <DropDown
                          limit={limit}
                          onLimitChange={(val) => setlimit(val)}
                        />
                      </div>
                    </div>
                  </div>

                  {loading ? (
                    <Loader />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 custom-table comman-table mb-0">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>Voucher No</th>
                            <th>Date</th>
                            <th>Received By</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {tableData?.map((elem, i) => (
                            <tr key={elem._id}>
                              <td>{(currentPage - 1) * limit + i + 1}</td>
                              <td>{elem?.voucher_no || "-"}</td>
                              <td>
                                {elem?.date
                                  ? moment(elem?.date).format("YYYY-MM-DD")
                                  : "-"}
                              </td>
                              <td>{elem?.received_by?.user_name || "-"}</td>
                              <td className="text-end">
                                <div className="dropdown dropdown-action">
                                  <a
                                    href="#"
                                    className="action-icon dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="fa fa-ellipsis-v"></i>
                                  </a>

                                  <div className="dropdown-menu dropdown-menu-end">
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate(
                                          "/user/project-store/view-item-receive",
                                          { state: elem }
                                        )
                                      }
                                    >
                                      <i className="fa-solid fa-eye m-r-5"></i>{" "}
                                      View
                                    </button>

                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate(
                                          "/user/project-store/manage-item-receive",
                                          { state: elem }
                                        )
                                      }
                                    >
                                      <i className="fa-solid fa-pen-to-square m-r-5"></i>{" "}
                                      Edit
                                    </button>

                                    <button
                                      type="button"
                                      onClick={() => handleDelete(elem?._id, elem?.voucher_no)}
                                      className="dropdown-item"
                                    >
                                      <i className="fa fa-trash-alt m-r-5"></i>{" "}
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}

                          {tableData.length === 0 && (
                            <tr>
                              <td colSpan="999">
                                <div className="no-table-data">
                                  No Data Found!
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6">
                      <div className="dataTables_info">
                        Showing {tableData.length} from {totalItems || 0}{" "}
                        data
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="dataTables_paginate paging_simple_numbers">
                        <Pagination
                          total={pagination?.totalCount || 0}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialReceiveList;
